import React, { useState, useMemo, useRef } from 'react';
import { cloneDeep } from 'lodash-es';
import ChartsIndex from '@/pages/intelligence/components/ChartsComponents/ChartsIndex';
import { ChartType } from '@/pages/intelligence/pages/TopCharts/_config/enums';
import { DATA_SOURCE_NAME_MAP } from '@/pages/intelligence/pages/TopCharts/_config/topChartsConst';
import { getPlatformName } from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/ActiveUserContext/_config/utils';
import useBarCharts from '@/pages/intelligence/components/Chart/hooks/useBarCharts';
import useLineCharts from '@/pages/intelligence/components/Chart/hooks/useLineCharts';
import { getCountryImg } from '@/pages/intelligence/utils/common';

const getSortedXAxisData = (xAxisData?: string[]): string[] => {
  if (!Array.isArray(xAxisData) || xAxisData.length === 0) {
    return [];
  }

  const sortedXAxisData = cloneDeep(xAxisData);

  sortedXAxisData.sort((a, b) => {
    const aNum = Number.parseInt(a?.substring(1), 10);
    const bNum = Number.parseInt(b?.substring(1), 10);

    if (Number.isNaN(aNum) && Number.isNaN(bNum)) {
      return 0;
    }

    if (Number.isNaN(aNum)) {
      return 1;
    }

    if (Number.isNaN(bNum)) {
      return -1;
    }

    return aNum > bNum ? 1 : -1;
  });

  return sortedXAxisData;
};

//每个榜单，组装好各类可视化需要的数据，传递给可视化统一组件
const Visualis: React.FC<any> = (props: any) => {
  const {
    chartType = ChartType.Line,
    lineData = [], // 折线 数据
    isNodata,
    secondTitleRight,
    lineSourceIcon,
  } = props;

  const [chartLoading, setChartLoading] = useState(false);

  //组装rpd折线图数据
  const getRpdTypeData = (list: any, _platform = '') => {
    if (!Array.isArray(list) || list?.length < 1) return [];
    let arr: any = [];
    for (let i in list) {
      arr.push({
        metric: _platform,
        source: 'appannie',
        time: list[i].name,
        value: list[i].value,
      });
    }
    return arr;
  };

  const lineSeriesData = useMemo(() => {
    let arrGameData: any = [];
    for (let n in lineData) {
      const gameObj = lineData[n];
      const objTemp = {
        cover: gameObj.cover,
        id: gameObj.app_id,
        name: `${gameObj.name}(${getPlatformName(gameObj?.platform)})`,
        history: getRpdTypeData(gameObj.metrics, gameObj?.platform),
      };
      arrGameData.push(objTemp);
    }
    const temp = {
      source: Array.isArray(arrGameData) ? arrGameData : [],
    };
    return temp;
  }, [lineData]);
  const xline =  (lineData: { [key: string]: any[]; }, metric: string) => {
    if (!lineData?.hasOwnProperty(metric)) return [];
    const listTmp = lineData?.[metric] || [];
    const linexAxisSetTmp: Set<string> = new Set();
    listTmp?.forEach((item: any) => {
      item?.history?.forEach((subItem: any) => {
        const historyTime = subItem?.time;
        if (historyTime) {
          linexAxisSetTmp.add(historyTime);
        }
      });
    });
    return getSortedXAxisData(Array.from(linexAxisSetTmp));
  };
  const lineXAxisData = xline(lineSeriesData,'source')
  // 获取折线图hooks
  const {
    lineOption
  } = useLineCharts({
    lineData: lineSeriesData,
    topChartsType: 'stats-retentionmonthly-trend',
    metric: 'source',
    secondTitleRight,
    lineSourceIcon,
    lineXAxisData,
  });

  return (
    <>
      <div className="card-line">
        <ChartsIndex
          chartLoading={chartLoading}
          lineOption={lineOption}
          chartType={chartType}
          isNodata={isNodata}
        />
      </div>
    </>
  );
};

export default Visualis;
